var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8621 14.1599C16.6967 12.9858 17.1875 11.5502 17.1875 10C17.1875 6.03045 13.9695 2.8125 10 2.8125C6.03045 2.8125 2.8125 6.03045 2.8125 10C2.8125 11.5502 3.30327 12.9858 4.13791 14.1598C7.65891 11.7183 12.3411 11.7183 15.8621 14.1599ZM14.8141 15.3372C11.8996 13.4092 8.1004 13.4092 5.18589 15.3372C6.46015 16.4873 8.1483 17.1875 10 17.1875C11.8517 17.1875 13.5398 16.4873 14.8141 15.3372ZM10 18.75C5.16751 18.75 1.25 14.8325 1.25 10C1.25 5.16751 5.16751 1.25 10 1.25C14.8325 1.25 18.75 5.16751 18.75 10C18.75 14.8325 14.8325 18.75 10 18.75ZM10 9.63327C9.24098 9.63327 8.62564 9.01793 8.62564 8.25887C8.62564 7.4998 9.24098 6.88446 10 6.88446C10.7591 6.88446 11.3745 7.4998 11.3745 8.25887C11.3745 9.01793 10.7591 9.63327 10 9.63327ZM10 11.1958C11.6221 11.1958 12.937 9.88088 12.937 8.25887C12.937 6.63686 11.6221 5.32196 10 5.32196C8.37804 5.32196 7.06314 6.63686 7.06314 8.25887C7.06314 9.88088 8.37804 11.1958 10 11.1958Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.24723338aa609ab4e56364aff970a1ee.svg";
export { ForwardRef as ReactComponent };